import { useState } from "react";
import Skeleton from "react-loading-skeleton";
import { Button } from "../../../themes/userq/Button/Button";
import { Icon } from "../../../themes/userq/Icon/Icon";
import { Preview } from "../../../themes/userq/Preview/preview";
import { Text } from "../../../themes/userq/Text/Text";
import GoalScreen from "./goal_screen";

export const DefineFlow = ({
    language,
    read_mode,
    device,
    start_screen,
    goal_screen,
    objective,
    updateGoalScreen,
    goal_screen_loading,
    resync_loading,
    error,
}) => {
    const [previewModal, setPreviewModal] = useState({
        open: false,
        img: null,
        background: "#FFFFFF",
        file_type: "image",
    });
    const [goalScreenOpen, setGoalScreenOpen] = useState(false);

    const isArabic = language === "ar";
    const isClosedObjective = objective === "closed";
    const isMobile = device === "mobile";
    const skeletonBtnStyle = {
        border: "none",
        display: "inline-flex",
        margin: "6px 10px 0px",
    };
    const getAssetUrl = (path) =>
        path && path.includes("https")
            ? path
            : `${process.env.REACT_APP_IMG_URL}${path}`;

    return (
        <div
            className={`define_flow_container ${isMobile ? "mobile-preview-define-flow" : ""
                } ${isArabic ? "arabic-wrapper" : ""}`}
        >
            {!read_mode && (
                <div className="figma-flow-top-head">
                    <Text type="subtitle-2" fontWeight="medium-font">
                        Where should the task end?
                    </Text>
                    {isClosedObjective && (
                        <Text type="body-text-2" fontWeight="medium-font">
                            Choose the screen participants reach when they complete the
                            task.
                        </Text>
                    )}
                </div>
            )}

            <div className="figma-define-row-wrap">
                <div className="define-start-design-box">
                    <div className="define-design-box-head">
                        {resync_loading ? (
                            <div
                                className={`skeleton-icon-wrapper ${isArabic ? "ar-icon-wrapper" : ""
                                    }`}
                            >
                                <Skeleton
                                    className={`skeleton-icon ${isArabic ? "ar-icon" : ""}`}
                                    width={24}
                                    style={{ borderRadius: "24px" }}
                                    height={24}
                                />
                            </div>
                        ) : (
                            <Icon
                                value="success"
                                colorClass="success-200-svg"
                                size="medium"
                            />
                        )}
                        <Text type="body-text-2" fontWeight="medium-font">
                            {isArabic ? "صفحة البداية" : "Start screen"}
                        </Text>
                    </div>

                    {resync_loading ? (
                        <div className="skeleton-height">
                            <Skeleton width="100%" height={120} />
                        </div>
                    ) : (
                        <div className="define-box-image-preview">
                            <div className="define-box-prew-inner">
                                <img src={getAssetUrl(start_screen.thumb)} alt="prototype" />
                            </div>
                        </div>
                    )}

                    <div className="define-box-btn-wrap">
                        {resync_loading ? (
                            <div style={skeletonBtnStyle}>
                                <Skeleton width={148} height={46} borderRadius={56} />
                            </div>
                        ) : (
                            !read_mode && (
                                <Button
                                    type="secondary"
                                    label={isArabic ? "عرض" : "Preview"}
                                    iconLeft={<Icon value="eye" size="medium" />}
                                    onClick={(e) => {
                                        e.preventDefault();
                                        setPreviewModal({
                                            ...previewModal,
                                            open: true,
                                            img: getAssetUrl(start_screen.file),
                                        });
                                    }}
                                />
                            )
                        )}
                    </div>
                </div>

                {isClosedObjective && (
                    <div className="define-design-arrow">
                        <Icon
                            value="forward-arrow"
                            colorClass="gray-600-svg"
                            size="large"
                        />
                    </div>
                )}

                {isClosedObjective && (
                    <div className="define-start-design-box goal-screen-design-box">
                        {goal_screen ? (
                            <>
                                <div className="define-design-box-head">
                                    <div className="defined-design-edit-left">
                                        {resync_loading ? (
                                            <div
                                                className={`skeleton-icon-wrapper ${isArabic ? "ar-icon-wrapper" : ""
                                                    }`}
                                            >
                                                <Skeleton
                                                    className={`skeleton-icon ${isArabic ? "ar-icon" : ""
                                                        }`}
                                                    width={24}
                                                    style={{ borderRadius: "24px" }}
                                                    height={24}
                                                />
                                            </div>
                                        ) : (
                                            <Icon
                                                value="success"
                                                colorClass="success-200-svg"
                                                size="medium"
                                            />
                                        )}
                                        <Text type="body-text-2" fontWeight="medium-font">
                                            {isArabic ? "صفحة الهدف" : "Goal screen"}
                                        </Text>
                                    </div>

                                    {!read_mode && (
                                        <span
                                            className="define-design-edit"
                                            onClick={() => setGoalScreenOpen(true)}
                                        >
                                            {resync_loading ? (
                                                <div
                                                    className={`skeleton-icon-wrapper ${isArabic ? "ar-icon-wrapper" : ""
                                                        }`}
                                                >
                                                    <Skeleton
                                                        className={`skeleton-icon ${isArabic ? "ar-icon" : ""
                                                            }`}
                                                        width={24}
                                                        style={{ marginRight: "8px" }}
                                                        height={24}
                                                    />
                                                </div>
                                            ) : (
                                                <Icon value="edit" size="medium" hover={true} />
                                            )}
                                        </span>
                                    )}
                                </div>

                                {resync_loading ? (
                                    <div className="skeleton-icon-wrapper-loading">
                                        <Skeleton width="100%" height={120} />
                                    </div>
                                ) : (
                                    <div className="define-box-image-preview">
                                        <div className="define-box-prew-inner">
                                            <img
                                                src={getAssetUrl(goal_screen.thumb)}
                                                alt="prototype"
                                            />
                                        </div>
                                    </div>
                                )}

                                <div className="define-box-btn-wrap">
                                    {resync_loading ? (
                                        <div style={skeletonBtnStyle}>
                                            <Skeleton width={165} height={46} borderRadius={56} />
                                        </div>
                                    ) : (
                                        !read_mode && (
                                            <Button
                                                type={goal_screen_loading ? "primary" : "secondary"}
                                                label={isArabic ? "عرض" : "Preview"}
                                                iconLeft={<Icon value="eye" size="medium" />}
                                                onClick={(e) => {
                                                    e.preventDefault();
                                                    setPreviewModal({
                                                        ...previewModal,
                                                        open: true,
                                                        img: getAssetUrl(goal_screen.file),
                                                    });
                                                }}
                                                microLoading={goal_screen_loading}
                                            />
                                        )
                                    )}
                                </div>
                            </>
                        ) : (
                            !read_mode && (
                                <>
                                    <div className="define-design-box-head">
                                        {resync_loading ? (
                                            <div
                                                className={`skeleton-icon-wrapper ${isArabic ? "ar-icon-wrapper" : ""
                                                    }`}
                                            >
                                                <Skeleton
                                                    className={`skeleton-icon ${isArabic ? "ar-icon" : ""
                                                        }`}
                                                    width={24}
                                                    style={{ borderRadius: "24px" }}
                                                    height={24}
                                                />
                                            </div>
                                        ) : (
                                            <Icon
                                                value="error"
                                                colorClass={error ? "danger-200-svg" : "gray-700-svg"}
                                                size="medium"
                                            />
                                        )}
                                        <Text type="body-text-2" fontWeight="medium-font">
                                            {isArabic ? "صفحة الهدف" : "Goal screen"}
                                        </Text>
                                    </div>

                                    {resync_loading ? (
                                        <div className="skeleton-height">
                                            <Skeleton width="100%" height={120} />
                                        </div>
                                    ) : (
                                        <div className="define-box-image-preview border-one-px-gray">
                                            <div className="define-box-prew-inner" />
                                        </div>
                                    )}

                                    <div className="define-box-btn-wrap">
                                        {resync_loading ? (
                                            <div style={skeletonBtnStyle}>
                                                <Skeleton width={148} height={46} borderRadius={56} />
                                            </div>
                                        ) : (
                                            <Button
                                                type="primary"
                                                label={
                                                    isArabic ? "حدد صفحة الهدف" : "Set a goal screen"
                                                }
                                                iconLeft={
                                                    <Icon
                                                        value="target"
                                                        colorClass="gray-50-svg"
                                                        size="medium"
                                                    />
                                                }
                                                onClick={(e) => {
                                                    e.preventDefault();
                                                    setGoalScreenOpen(true);
                                                }}
                                                microLoading={goal_screen_loading}
                                            />
                                        )}
                                    </div>
                                </>
                            )
                        )}
                    </div>
                )}
            </div>

            <Preview
                open={previewModal.open}
                withMinimizeIcon={true}
                background={previewModal.background}
                loading={false}
                file_type={previewModal.file_type}
                img={previewModal.img}
                close={() =>
                    setPreviewModal({
                        open: false,
                        img: null,
                        background: "#FFFFFF",
                        file_type: "image",
                    })
                }
            />

            <GoalScreen
                rtl={isArabic}
                file_key={start_screen.file_key}
                file_name={start_screen.file_name}
                source_node_id={start_screen.node_id}
                goal_node_id={goal_screen ? goal_screen.node_id : start_screen.node_id}
                version={start_screen.version}
                open={goalScreenOpen}
                close={() => setGoalScreenOpen(false)}
                updateGoalScreen={(node_id) => {
                    setGoalScreenOpen(false);
                    updateGoalScreen(node_id);
                }}
                device={device}
            />
        </div>
    );
};
